import { TrendingUp } from 'lucide-react';

import { Skeleton } from '@/_components/progress';
import { SectionHeading } from '@/_containers';

export const ForecastedRevenueLoading = () => {
  return (
    <>
      <SectionHeading text="Forecasted Revenue" icon={TrendingUp} />

      {/* Accordion skeleton */}
      <div className="mt-4 space-y-1">
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="rounded">
            {/* Accordion header */}
            <div className="flex items-center justify-between py-2">
              <Skeleton className="h-5 w-16" />
              <Skeleton className="h-5 w-32" />
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
